const NPDF_SKIP_KEY = "npdf-skip-date";
const getLocalTodayString = ()=>{
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
};
export const shouldSkipNPdfDialog = ()=>{
    const stored = localStorage.getItem(NPDF_SKIP_KEY);
    if (!stored) return false;
    const today = getLocalTodayString();
    return stored === today;
};
export const setSkipNPdfForToday = ()=>{
    const today = getLocalTodayString();
    localStorage.setItem(NPDF_SKIP_KEY, today);
};
